import { FieldSingleButton } from "../../../components";
import {
  distributionFormFields,
  manageDistributionFormNames,
} from "../../../utils";
import {
  DISTRIBUTION_WITHDRAWAL_MODE,
  getFilteredRkData,
  PaymentOptions,
} from "./DistributionConstantsAndFunctions";

const rothSources = [5, 6, 8, 9];
const formName = manageDistributionFormNames.WITHDRAWAL_REQUEST;
const fields = distributionFormFields[formName];

export const getSplitForAmount = (splits, amount, label) =>
  splits?.map((source) => {
    var sourceAmount = source.sourceFraction * amount;
    if (sourceAmount != 0 && !isNaN(amount)) {
      var basisAmount =
        (source.basisAccountBalance / source.accountBalance) * sourceAmount;
      var regularAmount =
        (source.regularAccountBalance / source.accountBalance) * sourceAmount;
      var repaymentAmount =
        (source.repaymentAccountBalance / source.accountBalance) * sourceAmount;
      return {
        ...source,
        [label]: sourceAmount,
        grossWithdrawalAmount:
          (source.grossWithdrawalAmount ?? 0) + sourceAmount,
        accountBalance: source.accountBalance - sourceAmount,
        basisCCBBalance:
          source.basisAccountBalance == 0
            ? 0
            : source.basisCCBBalance -
              (source.basisCCBBalance / source.basisAccountBalance) *
                basisAmount,
        basisEarningsBalance:
          source.basisAccountBalance == 0
            ? 0
            : source.basisEarningsBalance -
              (source.basisEarningsBalance / source.basisAccountBalance) *
                basisAmount,
        regularCCBBalance:
          source.regularAccountBalance == 0
            ? 0
            : source.regularCCBBalance -
              (source.regularCCBBalance / source.regularAccountBalance) *
                regularAmount,
        regularEarningsBalance:
          source.regularAccountBalance == 0
            ? 0
            : source.regularEarningsBalance -
              (source.regularEarningsBalance / source.regularAccountBalance) *
                regularAmount,
        repaymentCCBBalance:
          source.repaymentAccountBalance == 0
            ? 0
            : source.repaymentCCBBalance -
              (source.repaymentCCBBalance / source.repaymentAccountBalance) *
                repaymentAmount,
        repaymentEarningsBalance:
          source.repaymentAccountBalance == 0
            ? 0
            : source.repaymentEarningsBalance -
              (source.repaymentEarningsBalance /
                source.repaymentAccountBalance) *
                repaymentAmount,
        regularAccountBalance:
          source.regularAccountBalance == 0
            ? 0
            : source.regularAccountBalance - regularAmount,
        basisAccountBalance:
          source.basisAccountBalance == 0
            ? 0
            : source.basisAccountBalance - basisAmount,
        repaymentAccountBalance:
          source.repaymentAccountBalance == 0
            ? 0
            : source.repaymentAccountBalance - repaymentAmount,
        sourceInvestmentBalances: source.sourceInvestmentBalances?.map(
          (investment) => {
            var investmentAmount = sourceAmount * investment.investmentFraction;
            var invBasisAmount =
              (investment.basisAccountBalance / investment.accountBalance) *
              investmentAmount;
            var invRegularAmount =
              (investment.regularAccountBalance / investment.accountBalance) *
              investmentAmount;
            var invRepaymentAmount =
              (investment.basisAccountBalance / investment.accountBalance) *
              investmentAmount;
            return {
              ...investment,
              [label]: investmentAmount,
              grossWithdrawalAmount:
                (investment.grossWithdrawalAmount ?? 0) + investmentAmount,
              accountBalance: investment.accountBalance - investmentAmount,
              basisCCBBalance:
                investment.basisAccountBalance == 0
                  ? 0
                  : investment.basisCCBBalance -
                    (investment.basisCCBBalance /
                      investment.basisAccountBalance) *
                      invBasisAmount,
              basisEarningsBalance:
                investment.basisAccountBalance == 0
                  ? 0
                  : investment.basisEarningsBalance -
                    (investment.basisEarningsBalance /
                      investment.basisAccountBalance) *
                      invBasisAmount,
              regularCCBBalance:
                investment.regularAccountBalance == 0
                  ? 0
                  : investment.regularCCBBalance -
                    (investment.regularCCBBalance /
                      investment.regularAccountBalance) *
                      invRegularAmount,
              regularEarningsBalance:
                investment.regularAccountBalance == 0
                  ? 0
                  : investment.regularEarningsBalance -
                    (investment.regularEarningsBalance /
                      investment.regularAccountBalance) *
                      invRegularAmount,
              repaymentCCBBalance:
                investment.repaymentAccountBalance == 0
                  ? 0
                  : investment.repaymentCCBBalance -
                    (investment.repaymentCCBBalance /
                      investment.repaymentAccountBalance) *
                      invRepaymentAmount,
              repaymentEarningsBalance:
                investment.repaymentAccountBalance == 0
                  ? 0
                  : investment.repaymentEarningsBalance -
                    (investment.repaymentEarningsBalance /
                      investment.repaymentAccountBalance) *
                      invRepaymentAmount,
              regularAccountBalance:
                investment.regularAccountBalance == 0
                  ? 0
                  : investment.regularAccountBalance - invRegularAmount,
              basisAccountBalance:
                investment.basisAccountBalance == 0
                  ? 0
                  : investment.basisAccountBalance - invBasisAmount,
              repaymentAccountBalance:
                investment.repaymentAccountBalance == 0
                  ? 0
                  : investment.repaymentAccountBalance - invRepaymentAmount,
            };
          }
        ),
      };
    } else {
      return {
        ...source,
        [label]: 0,
        grossWithdrawalAmount: source.grossWithdrawalAmount ?? 0,
        sourceInvestmentBalances: source.sourceInvestmentBalances?.map(
          (investment) => {
            return {
              ...investment,
              [label]: 0,
            };
          }
        ),
      };
    }
  });

export const getSplitForAmountGross = (splits, amount, label) =>
  splits?.map((source) => {
    var sourceAmount = source.sourceFraction * amount;
    if (sourceAmount != 0 && !isNaN(amount)) {
      var basisAmount =
        (source.basisAccountBalance / source.accountBalance) * sourceAmount;
      var regularAmount =
        (source.regularAccountBalance / source.accountBalance) * sourceAmount;
      var repaymentAmount =
        (source.repaymentAccountBalance / source.accountBalance) * sourceAmount;
      return {
        ...source,
        [label]: sourceAmount,
        requestedAmount:
          (source.requestedAmount ?? source.accountBalance) - sourceAmount,
        accountBalance: source.accountBalance - sourceAmount,
        basisCCBBalance:
          source.basisAccountBalance == 0
            ? 0
            : source.basisCCBBalance -
              (source.basisCCBBalance / source.basisAccountBalance) *
                basisAmount,
        basisEarningsBalance:
          source.basisAccountBalance == 0
            ? 0
            : source.basisEarningsBalance -
              (source.basisEarningsBalance / source.basisAccountBalance) *
                basisAmount,
        regularCCBBalance:
          source.regularAccountBalance == 0
            ? 0
            : source.regularCCBBalance -
              (source.regularCCBBalance / source.regularAccountBalance) *
                regularAmount,
        regularEarningsBalance:
          source.regularAccountBalance == 0
            ? 0
            : source.regularEarningsBalance -
              (source.regularEarningsBalance / source.regularAccountBalance) *
                regularAmount,
        repaymentCCBBalance:
          source.repaymentAccountBalance == 0
            ? 0
            : source.repaymentCCBBalance -
              (source.repaymentCCBBalance / source.repaymentAccountBalance) *
                repaymentAmount,
        repaymentEarningsBalance:
          source.repaymentAccountBalance == 0
            ? 0
            : source.repaymentEarningsBalance -
              (source.repaymentEarningsBalance /
                source.repaymentAccountBalance) *
                repaymentAmount,
        regularAccountBalance:
          source.regularAccountBalance == 0
            ? 0
            : source.regularAccountBalance - regularAmount,
        basisAccountBalance:
          source.basisAccountBalance == 0
            ? 0
            : source.basisAccountBalance - basisAmount,
        repaymentAccountBalance:
          source.repaymentAccountBalance == 0
            ? 0
            : source.repaymentAccountBalance - repaymentAmount,
        sourceInvestmentBalances: source.sourceInvestmentBalances.map(
          (investment) => {
            var investmentAmount = sourceAmount * investment.investmentFraction;
            var invBasisAmount =
              (investment.basisAccountBalance / investment.accountBalance) *
              investmentAmount;
            var invRegularAmount =
              (investment.regularAccountBalance / investment.accountBalance) *
              investmentAmount;
            var invRepaymentAmount =
              (investment.basisAccountBalance / investment.accountBalance) *
              investmentAmount;
            return {
              ...investment,
              [label]: investmentAmount,
              requestedAmount:
                (investment.requestedAmount ??
                  investment.accountBalance * source.vestingMultiplier) -
                investmentAmount,
              accountBalance: investment.accountBalance - investmentAmount,
              basisCCBBalance:
                investment.basisAccountBalance == 0
                  ? 0
                  : investment.basisCCBBalance -
                    (investment.basisCCBBalance /
                      investment.basisAccountBalance) *
                      invBasisAmount,
              basisEarningsBalance:
                investment.basisAccountBalance == 0
                  ? 0
                  : investment.basisEarningsBalance -
                    (investment.basisEarningsBalance /
                      investment.basisAccountBalance) *
                      invBasisAmount,
              regularCCBBalance:
                investment.regularAccountBalance == 0
                  ? 0
                  : investment.regularCCBBalance -
                    (investment.regularCCBBalance /
                      investment.regularAccountBalance) *
                      invRegularAmount,
              regularEarningsBalance:
                investment.regularAccountBalance == 0
                  ? 0
                  : investment.regularEarningsBalance -
                    (investment.regularEarningsBalance /
                      investment.regularAccountBalance) *
                      invRegularAmount,
              repaymentCCBBalance:
                investment.repaymentAccountBalance == 0
                  ? 0
                  : investment.repaymentCCBBalance -
                    (investment.repaymentCCBBalance /
                      investment.repaymentAccountBalance) *
                      invRepaymentAmount,
              repaymentEarningsBalance:
                investment.repaymentAccountBalance == 0
                  ? 0
                  : investment.repaymentEarningsBalance -
                    (investment.repaymentEarningsBalance /
                      investment.repaymentAccountBalance) *
                      invRepaymentAmount,
              regularAccountBalance:
                investment.regularAccountBalance == 0
                  ? 0
                  : investment.regularAccountBalance - invRegularAmount,
              basisAccountBalance:
                investment.basisAccountBalance == 0
                  ? 0
                  : investment.basisAccountBalance - invBasisAmount,
              repaymentAccountBalance:
                investment.repaymentAccountBalance == 0
                  ? 0
                  : investment.repaymentAccountBalance - invRepaymentAmount,
            };
          }
        ),
      };
    } else {
      return {
        ...source,
        [label]: 0,
        requestedAmount: source.requestedAmount ?? 0,
        sourceInvestmentBalances: source.sourceInvestmentBalances?.map(
          (investment) => {
            return {
              ...investment,
              [label]: 0,
              requestedAmount: investment.requestedAmount ?? 0,
            };
          }
        ),
      };
    }
  });

export const getTaxAmount = (source, isRoth, taxPercentage) =>
  ((isRoth ? source.taxableEarningsFraction : 1) *
    source.requestedAmount *
    taxPercentage) /
    100 ?? 0;

export const getNetFromGrossAndPercentage = (gross, percentage) =>
  gross / (1 + percentage / 100);

export const getTaxAmountGross = (source, isRoth, taxPercentage) =>
  getNetFromGrossAndPercentage(
    source.requestedAmount,
    (isRoth ? source.taxableEarningsFraction ?? 0 : 1) * taxPercentage
  );

export const getSplitForTaxes = (splits, taxPercentage, label) =>
  splits?.map((source) => {
    var isRoth = rothSources.includes(source.sourceSubCategory);
    var amount =
      taxPercentage == 0 ? 0 : getTaxAmount(source, isRoth, taxPercentage);
    let earningsAmount,
      basisEarningsAmount,
      regularEarningsAmount,
      repaymentEarningsAmount,
      basisAmount,
      regularAmount,
      repaymentAmount = 0;
    if (amount != 0 && !isNaN(amount)) {
      if (isRoth) {
        earningsAmount =
          source.basisEarningsBalance +
          source.regularEarningsBalance +
          source.repaymentEarningsBalance;
        basisEarningsAmount =
          (source.basisEarningsBalance / earningsAmount) * amount;
        regularEarningsAmount =
          (source.regularEarningsBalance / earningsAmount) * amount;
        repaymentEarningsAmount =
          (source.repaymentEarningsBalance / earningsAmount) * amount;
      } else {
        basisAmount =
          (source.basisAccountBalance / source.accountBalance) * amount;
        regularAmount =
          (source.regularAccountBalance / source.accountBalance) * amount;
        repaymentAmount =
          (source.repaymentAccountBalance / source.accountBalance) * amount;
      }
      return {
        ...source,
        [label]: amount,
        grossWithdrawalAmount: (source.grossWithdrawalAmount ?? 0) + amount,
        accountBalance: source.accountBalance - amount,
        basisCCBBalance: isRoth
          ? source.basisCCBBalance
          : source.basisAccountBalance == 0
          ? 0
          : source.basisCCBBalance -
            (source.basisCCBBalance / source.basisAccountBalance) * basisAmount,
        basisEarningsBalance:
          source.basisAccountBalance == 0
            ? 0
            : isRoth
            ? source.basisEarningsBalance - basisEarningsAmount
            : source.basisEarningsBalance -
              (source.basisEarningsBalance / source.basisAccountBalance) *
                basisAmount,
        regularCCBBalance: isRoth
          ? source.regularCCBBalance
          : source.regularAccountBalance == 0
          ? 0
          : source.regularCCBBalance -
            (source.regularCCBBalance / source.regularAccountBalance) *
              regularAmount,
        regularEarningsBalance:
          source.regularAccountBalance == 0
            ? 0
            : isRoth
            ? source.regularEarningsBalance - regularEarningsAmount
            : source.regularEarningsBalance -
              (source.regularEarningsBalance / source.regularAccountBalance) *
                regularAmount,
        repaymentCCBBalance: isRoth
          ? source.repaymentCCBBalance
          : source.repaymentAccountBalance == 0
          ? 0
          : source.repaymentCCBBalance -
            (source.repaymentCCBBalance / source.repaymentAccountBalance) *
              repaymentAmount,
        repaymentEarningsBalance:
          source.repaymentAccountBalance == 0
            ? 0
            : isRoth
            ? source.repaymentEarningsBalance - repaymentEarningsAmount
            : source.repaymentEarningsBalance -
              (source.repaymentEarningsBalance /
                source.repaymentAccountBalance) *
                repaymentAmount,
        regularAccountBalance:
          source.regularAccountBalance == 0
            ? 0
            : isRoth
            ? source.regularAccountBalance - regularEarningsAmount
            : source.regularAccountBalance - regularAmount,
        basisAccountBalance:
          source.basisAccountBalance == 0
            ? 0
            : isRoth
            ? source.basisAccountBalance - basisEarningsAmount
            : source.basisAccountBalance - basisAmount,
        repaymentAccountBalance:
          source.repaymentAccountBalance == 0
            ? 0
            : isRoth
            ? source.repaymentAccountBalance - repaymentEarningsAmount
            : source.repaymentAccountBalance - repaymentAmount,
        sourceInvestmentBalances: source.sourceInvestmentBalances.map(
          (investment) => {
            var investmentAmount = amount * investment.investmentFraction;
            let invEarningsAmount,
              invBasisEarningsAmount,
              invRegularEarningsAmount,
              invRepaymentEarningsAmount,
              invBasisAmount,
              invRegularAmount,
              invRepaymentAmount = 0;
            if (isRoth) {
              invEarningsAmount =
                investment.basisEarningsBalance +
                investment.regularEarningsBalance +
                investment.repaymentEarningsBalance;
              invBasisEarningsAmount =
                (investment.basisEarningsBalance / invEarningsAmount) *
                investmentAmount;
              invRegularEarningsAmount =
                (investment.regularEarningsBalance / invEarningsAmount) *
                investmentAmount;
              invRepaymentEarningsAmount =
                (investment.repaymentEarningsBalance / invEarningsAmount) *
                investmentAmount;
            } else {
              invBasisAmount =
                (investment.basisAccountBalance / investment.accountBalance) *
                investmentAmount;
              invRegularAmount =
                (investment.regularAccountBalance / investment.accountBalance) *
                investmentAmount;
              invRepaymentAmount =
                (investment.basisAccountBalance / investment.accountBalance) *
                investmentAmount;
            }
            return {
              ...investment,
              [label]: investmentAmount,
              grossWithdrawalAmount:
                (investment?.grossWithdrawalAmount ?? 0) + investmentAmount,
              accountBalance: investment.accountBalance - investmentAmount,
              basisCCBBalance: isRoth
                ? investment.basisCCBBalance
                : investment.basisAccountBalance == 0
                ? 0
                : investment.basisCCBBalance -
                  (investment.basisCCBBalance /
                    investment.basisAccountBalance) *
                    invBasisAmount,
              basisEarningsBalance:
                investment.basisAccountBalance == 0
                  ? 0
                  : isRoth
                  ? investment.basisEarningsBalance - invBasisEarningsAmount
                  : investment.basisEarningsBalance -
                    (investment.basisEarningsBalance /
                      investment.basisAccountBalance) *
                      invBasisAmount,
              regularCCBBalance: isRoth
                ? investment.regularCCBBalance
                : investment.regularAccountBalance == 0
                ? 0
                : investment.regularCCBBalance -
                  (investment.regularCCBBalance /
                    investment.regularAccountBalance) *
                    invRegularAmount,
              regularEarningsBalance:
                investment.regularAccountBalance == 0
                  ? 0
                  : isRoth
                  ? investment.regularEarningsBalance - invRegularEarningsAmount
                  : investment.regularEarningsBalance -
                    (investment.regularEarningsBalance /
                      investment.regularAccountBalance) *
                      invRegularAmount,
              repaymentCCBBalance: isRoth
                ? investment.repaymentCCBBalance
                : investment.repaymentAccountBalance == 0
                ? 0
                : investment.repaymentCCBBalance -
                  (investment.repaymentCCBBalance /
                    investment.repaymentAccountBalance) *
                    invRepaymentAmount,
              repaymentEarningsBalance:
                investment.repaymentAccountBalance == 0
                  ? 0
                  : isRoth
                  ? investment.repaymentEarningsBalance -
                    invRepaymentEarningsAmount
                  : investment.repaymentEarningsBalance -
                    (investment.repaymentEarningsBalance /
                      investment.repaymentAccountBalance) *
                      invRepaymentAmount,
              regularAccountBalance:
                investment.regularAccountBalance == 0
                  ? 0
                  : isRoth
                  ? investment.regularAccountBalance - invRegularEarningsAmount
                  : investment.regularAccountBalance - invRegularAmount,
              basisAccountBalance:
                investment.basisAccountBalance == 0
                  ? 0
                  : isRoth
                  ? investment.basisAccountBalance - invBasisEarningsAmount
                  : investment.basisAccountBalance - invBasisAmount,
              repaymentAccountBalance:
                investment.repaymentAccountBalance == 0
                  ? 0
                  : isRoth
                  ? investment.repaymentAccountBalance -
                    invRepaymentEarningsAmount
                  : investment.repaymentAccountBalance - invRepaymentAmount,
            };
          }
        ),
      };
    } else {
      return {
        ...source,
        [label]: 0,
        grossWithdrawalAmount: source.grossWithdrawalAmount ?? 0,
        sourceInvestmentBalances: source.sourceInvestmentBalances?.map(
          (investment) => {
            return {
              ...investment,
              [label]: 0,
            };
          }
        ),
      };
    }
  });

export const getSplitForTaxesGross = (splits, taxPercentage, label) =>
  splits?.map((source) => {
    var isRoth = rothSources.includes(source.sourceSubCategory);
    var amount =
      source.requestedAmount == 0
        ? 0
        : source.requestedAmount -
          getTaxAmountGross(source, isRoth, taxPercentage);
    let earningsAmount,
      basisEarningsAmount,
      regularEarningsAmount,
      repaymentEarningsAmount,
      basisAmount,
      regularAmount,
      repaymentAmount = 0;
    if (amount != 0 && !isNaN(amount)) {
      if (isRoth) {
        earningsAmount =
          source.basisEarningsBalance +
          source.regularEarningsBalance +
          source.repaymentEarningsBalance;
        basisEarningsAmount =
          (source.basisEarningsBalance / earningsAmount) * amount;
        regularEarningsAmount =
          (source.regularEarningsBalance / earningsAmount) * amount;
        repaymentEarningsAmount =
          (source.repaymentEarningsBalance / earningsAmount) * amount;
      } else {
        basisAmount =
          (source.basisAccountBalance / source.accountBalance) * amount;
        regularAmount =
          (source.regularAccountBalance / source.accountBalance) * amount;
        repaymentAmount =
          (source.repaymentAccountBalance / source.accountBalance) * amount;
      }
      return {
        ...source,
        [label]: amount,
        requestedAmount:
          (source.requestedAmount ?? source.accountBalance) - amount,
        accountBalance: source.accountBalance - amount,
        basisCCBBalance: isRoth
          ? source.basisCCBBalance
          : source.basisAccountBalance == 0
          ? 0
          : source.basisCCBBalance -
            (source.basisCCBBalance / source.basisAccountBalance) * basisAmount,
        basisEarningsBalance:
          source.basisAccountBalance == 0
            ? 0
            : isRoth
            ? source.basisEarningsBalance - basisEarningsAmount
            : source.basisEarningsBalance -
              (source.basisEarningsBalance / source.basisAccountBalance) *
                basisAmount,
        regularCCBBalance: isRoth
          ? source.regularCCBBalance
          : source.regularAccountBalance == 0
          ? 0
          : source.regularCCBBalance -
            (source.regularCCBBalance / source.regularAccountBalance) *
              regularAmount,
        regularEarningsBalance:
          source.regularAccountBalance == 0
            ? 0
            : isRoth
            ? source.regularEarningsBalance - regularEarningsAmount
            : source.regularEarningsBalance -
              (source.regularEarningsBalance / source.regularAccountBalance) *
                regularAmount,
        repaymentCCBBalance: isRoth
          ? source.repaymentCCBBalance
          : source.repaymentAccountBalance == 0
          ? 0
          : source.repaymentCCBBalance -
            (source.repaymentCCBBalance / source.repaymentAccountBalance) *
              repaymentAmount,
        repaymentEarningsBalance:
          source.repaymentAccountBalance == 0
            ? 0
            : isRoth
            ? source.repaymentEarningsBalance - repaymentEarningsAmount
            : source.repaymentEarningsBalance -
              (source.repaymentEarningsBalance /
                source.repaymentAccountBalance) *
                repaymentAmount,
        regularAccountBalance:
          source.regularAccountBalance == 0
            ? 0
            : isRoth
            ? source.regularAccountBalance - regularEarningsAmount
            : source.regularAccountBalance - regularAmount,
        basisAccountBalance:
          source.basisAccountBalance == 0
            ? 0
            : isRoth
            ? source.basisAccountBalance - basisEarningsAmount
            : source.basisAccountBalance - basisAmount,
        repaymentAccountBalance:
          source.repaymentAccountBalance == 0
            ? 0
            : isRoth
            ? source.repaymentAccountBalance - repaymentEarningsAmount
            : source.repaymentAccountBalance - repaymentAmount,
        sourceInvestmentBalances: source.sourceInvestmentBalances.map(
          (investment) => {
            var investmentAmount = amount * investment.investmentFraction;
            let invEarningsAmount,
              invBasisEarningsAmount,
              invRegularEarningsAmount,
              invRepaymentEarningsAmount,
              invBasisAmount,
              invRegularAmount,
              invRepaymentAmount = 0;
            if (isRoth) {
              invEarningsAmount =
                investment.basisEarningsBalance +
                investment.regularEarningsBalance +
                investment.repaymentEarningsBalance;
              invBasisEarningsAmount =
                (investment.basisEarningsBalance / invEarningsAmount) *
                investmentAmount;
              invRegularEarningsAmount =
                (investment.regularEarningsBalance / invEarningsAmount) *
                investmentAmount;
              invRepaymentEarningsAmount =
                (investment.repaymentEarningsBalance / invEarningsAmount) *
                investmentAmount;
            } else {
              invBasisAmount =
                (investment.basisAccountBalance / investment.accountBalance) *
                investmentAmount;
              invRegularAmount =
                (investment.regularAccountBalance / investment.accountBalance) *
                investmentAmount;
              invRepaymentAmount =
                (investment.basisAccountBalance / investment.accountBalance) *
                investmentAmount;
            }
            return {
              ...investment,
              [label]: investmentAmount,
              requestedAmount:
                (investment?.requestedAmount ??
                  investment.accountBalance * source.vestingMultiplier) -
                investmentAmount,
              accountBalance: investment.accountBalance - investmentAmount,
              basisCCBBalance: isRoth
                ? investment.basisCCBBalance
                : investment.basisAccountBalance == 0
                ? 0
                : investment.basisCCBBalance -
                  (investment.basisCCBBalance /
                    investment.basisAccountBalance) *
                    invBasisAmount,
              basisEarningsBalance:
                investment.basisAccountBalance == 0
                  ? 0
                  : isRoth
                  ? investment.basisEarningsBalance - invBasisEarningsAmount
                  : investment.basisEarningsBalance -
                    (investment.basisEarningsBalance /
                      investment.basisAccountBalance) *
                      invBasisAmount,
              regularCCBBalance: isRoth
                ? investment.regularCCBBalance
                : investment.regularAccountBalance == 0
                ? 0
                : investment.regularCCBBalance -
                  (investment.regularCCBBalance /
                    investment.regularAccountBalance) *
                    invRegularAmount,
              regularEarningsBalance:
                investment.regularAccountBalance == 0
                  ? 0
                  : isRoth
                  ? investment.regularEarningsBalance - invRegularEarningsAmount
                  : investment.regularEarningsBalance -
                    (investment.regularEarningsBalance /
                      investment.regularAccountBalance) *
                      invRegularAmount,
              repaymentCCBBalance: isRoth
                ? investment.repaymentCCBBalance
                : investment.repaymentAccountBalance == 0
                ? 0
                : investment.repaymentCCBBalance -
                  (investment.repaymentCCBBalance /
                    investment.repaymentAccountBalance) *
                    invRepaymentAmount,
              repaymentEarningsBalance:
                investment.repaymentAccountBalance == 0
                  ? 0
                  : isRoth
                  ? investment.repaymentEarningsBalance -
                    invRepaymentEarningsAmount
                  : investment.repaymentEarningsBalance -
                    (investment.repaymentEarningsBalance /
                      investment.repaymentAccountBalance) *
                      invRepaymentAmount,
              regularAccountBalance:
                investment.regularAccountBalance == 0
                  ? 0
                  : isRoth
                  ? investment.regularAccountBalance - invRegularEarningsAmount
                  : investment.regularAccountBalance - invRegularAmount,
              basisAccountBalance:
                investment.basisAccountBalance == 0
                  ? 0
                  : isRoth
                  ? investment.basisAccountBalance - invBasisEarningsAmount
                  : investment.basisAccountBalance - invBasisAmount,
              repaymentAccountBalance:
                investment.repaymentAccountBalance == 0
                  ? 0
                  : isRoth
                  ? investment.repaymentAccountBalance -
                    invRepaymentEarningsAmount
                  : investment.repaymentAccountBalance - invRepaymentAmount,
            };
          }
        ),
      };
    } else {
      return {
        ...source,
        [label]: 0,
        requestedAmount: source.requestedAmount ?? 0,
        sourceInvestmentBalances: source.sourceInvestmentBalances?.map(
          (investment) => {
            return {
              ...investment,
              [label]: 0,
              requestedAmount: investment.requestedAmount ?? 0,
            };
          }
        ),
      };
    }
  });

export const getDate = (date) => new Date(date);

export const getGrossAmount = (rkData, transaction, withdrawal, values) => {
  var splits = getFilteredRkData(rkData, false, withdrawal, transaction);
  splits = getSplitForAmount(
    splits,
    transaction[fields.requestedAmount] ?? 0,
    fields.requestedAmount
  );
  if (transaction.distributionMode == 1) {
    splits = getSplitForAmount(
      splits,
      transaction[fields.withdrawalFee] ?? 0,
      fields.withdrawalFee
    );
  } else {
    splits = getSplitForAmount(
      splits,
      transaction[fields.rollOverFee] ?? 0,
      fields.rollOverFee
    );
  }
  if (transaction[fields.paymentMethod] == 2)
    splits = getSplitForAmount(
      splits,
      transaction[fields.eftFee] ?? 0,
      fields.eftFee
    );
  if (transaction[fields.paymentMethod] == 1)
    splits = getSplitForAmount(
      splits,
      transaction[fields.checkFee] ?? 0,
      fields.checkFee
    );
  splits = getSplitForTaxes(
    splits,
    transaction[fields.stateTax] ?? 0,
    fields.stateTax
  );
  splits = getSplitForTaxes(
    splits,
    transaction[fields.federalTax] ?? 0,
    fields.federalTax
  );
  if (
    values[fields.withdrawalType] == 1 ||
    values[fields.withdrawalType] == 2
  ) {
    if (transaction[fields.waiveOffLimitApplicable] == false) {
      let x =
        (splits?.reduce((x, y) => x + y.grossWithdrawalAmount, 0) *
          (transaction[fields.earlyWithdrawalPenalty] ?? 0)) /
        100;
      splits = getSplitForAmount(splits, x ?? 0, fields.earlyWithdrawalPenalty);
    }
    if (transaction[fields.waiveOffLimitApplicable] == true) {
      let x =
        (splits?.reduce((x, y) => x + y.grossWithdrawalAmount, 0) *
          ((transaction[fields.earlyWithdrawalPenalty] ?? 0) -
            (transaction[fields.waiveOffLimit] ?? 0))) /
        100;
      splits = getSplitForAmount(splits, x ?? 0, fields.earlyWithdrawalPenalty);
    }
  }
  return splits;
};

export const getNetAmount = (
  rkData,
  transaction,
  withdrawal,
  values,
  maximumAmount
) => {
  var splits = getFilteredRkData(
    rkData,
    true,
    withdrawal,
    transaction,
    maximumAmount
  );
  var totalGrossAmount = splits?.reduce((x, y) => x + y.accountBalance, 0);
  var updatedGross =
    totalGrossAmount < maximumAmount ? totalGrossAmount : maximumAmount;
  if (
    values[fields.withdrawalType] == 1 ||
    values[fields.withdrawalType] == 2
  ) {
    var penalty =
      updatedGross -
      getNetFromGrossAndPercentage(
        updatedGross,
        transaction[fields.earlyWithdrawalPenalty] ?? 0
      );
    var waiveOffAmount =
      updatedGross -
      getNetFromGrossAndPercentage(
        updatedGross,
        transaction[fields.waiveOffLimit] ?? 0
      );
    if (transaction[fields.waiveOffLimitApplicable] == true) {
      penalty -= waiveOffAmount;
    }
    splits = getSplitForAmountGross(
      splits,
      penalty,
      fields.earlyWithdrawalPenalty
    );
  }
  splits = getSplitForTaxesGross(
    splits,
    transaction[fields.federalTax] ?? 0,
    fields.federalTax
  );
  splits = getSplitForTaxesGross(
    splits,
    transaction[fields.stateTax] ?? 0,
    fields.stateTax
  );
  if (transaction[fields.paymentMethod] == 2)
    splits = getSplitForAmountGross(
      splits,
      transaction[fields.eftFee] ?? 0,
      fields.eftFee
    );
  if (transaction[fields.paymentMethod] == 1)
    splits = getSplitForAmountGross(
      splits,
      transaction[fields.checkFee] ?? 0,
      fields.checkFee
    );
  if (transaction.distributionMode == 1) {
    splits = getSplitForAmountGross(
      splits,
      transaction[fields.withdrawalFee] ?? 0,
      fields.withdrawalFee
    );
  } else {
    splits = getSplitForAmountGross(
      splits,
      transaction[fields.rollOverFee] ?? 0,
      fields.rollOverFee
    );
  }
  return splits;
};

export const getTotalFees = (transaction) => {
  var fees = 0;
  if (
    transaction[fields.distributionMode] ==
    DISTRIBUTION_WITHDRAWAL_MODE.traditional_IRA
  )
    transaction[fields.rollOverFee]
      ? (fees += transaction[fields.rollOverFee])
      : (fees += 0);
  if (transaction[fields.paymentMethod] == PaymentOptions.EFT)
    transaction[fields.eftFee]
      ? (fees += transaction[fields.eftFee])
      : (fees += 0);
  if (transaction[fields.paymentMethod] == PaymentOptions.MailCheckToAddress)
    transaction[fields.checkFee]
      ? (fees += transaction[fields.checkFee])
      : (fees += 0);
  return fees;
};

export const CalculateSourceSplit = (
  rkData,
  transaction,
  withdrawal,
  values,
  isLastTransaction,
  step,
  maximumAmount
) => {
  var splits;
  if (
    values[fields.withdrawEntireAmount] &&
    // !transaction[fields.requestedAmount] &&
    isLastTransaction &&
    step == 1
  ) {
    splits = getNetAmount(
      rkData,
      transaction,
      withdrawal,
      values,
      maximumAmount
    );
  } else {
    splits = getGrossAmount(rkData, transaction, withdrawal, values);
  }
  var grossWithdrawalAmount = splits?.reduce(
    (x, y) => x + y.grossWithdrawalAmount,
    0
  );
  var stateTax = splits?.reduce((x, y) => x + y[fields.stateTax], 0);
  var federalTax = splits?.reduce((x, y) => x + y[fields.federalTax], 0);
  var pen = splits?.reduce((x, y) => x + y[fields.earlyWithdrawalPenalty], 0);
  var penalty = pen > 0 ? pen : 0;
  var requestedAmount = splits?.reduce((x, y) => x + y.requestedAmount, 0);
  return {
    grossWithdrawalAmount,
    stateTax,
    federalTax,
    penalty,
    totalTaxesAndPenalty: stateTax + federalTax + penalty,
    sourceSplit: splits,
    requestedAmount,
    updatedSourceSplit: rkData?.map((source) => {
      var s = splits.find((x) => x.sourceId == source.sourceId);
      if (s) {
        return {
          ...s,
          sourceEmployeeMap: {
            ...s,
          },
          sourceInvestmentBalances: s.sourceInvestmentBalances.map((x) => {
            return {
              ...x,
              sourceEmployeeInvestmentMap: { ...x },
            };
          }),
        };
      }
      return source;
    }),
  };
};
